import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import CommonTable from 'components/commonTable/CommonTable';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import AllotDialog from 'components/allotDialog/AllotDialog';
import { getRequestVehicle, updateAssignVehicle } from 'redux/actions/UserAllot';
import { getAssignDriver } from 'redux/actions/UserTrip';
import Loader from 'components/loader/Loader';

function AssignVechileView() {
  const dispatch = useDispatch();
  const id = localStorage.getItem('companyId')
  const userId = localStorage.getItem('ID')

  const [value, setValue] = useState('requested');
  const [openDialog, setOpenDialog] = useState(false);
  const [vehicleId, setVehicleId] = useState('')
  const driverData = useSelector((state) => state?.userDriver?.userDriver?.data)
  const assignDriverData = useSelector((state) => state?.userAssignDriver?.userAssignDriver?.data)
  const assignDriverLoader = useSelector((state) => state?.userAssignDriver?.loading)
  const tableData = useSelector((state) => state?.userRequestVehicle?.userRequestVehicle?.data)
  const loader = useSelector((state) => state?.userRequestVehicle?.loading)
  const [searchQuery, setSearchQuery] = useState("");
  const [filterDrivers, setFilterDrivers] = useState(assignDriverData)
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  let filterData = {
    assignId: id,
    status: "",
    page: page,
    pageSize: rowsPerPage,
    type: value
  }
  let filterDataDriver = {
    assignId: userId,
    status: "",
    page: "",
    pageSize: "",
    type: 'assignVehicle'
  }

  useEffect(() => {
    setFilterDrivers(assignDriverData)
  }, [assignDriverData])



  useEffect(() => {
    dispatch(getRequestVehicle(filterData));
  }, []);

  useEffect(() => {
    filterAllDrivers()
  }, [searchQuery])

  const onClickTableVendor = (data) => {
    setVehicleId(data?.id)
    dispatch(getAssignDriver({vehicleId:data?.id}));
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setPage(0);
    filterData = { ...filterData, type: newValue, page: 0 }
    dispatch(getRequestVehicle(filterData));
  };

  const submittAssign = (data) => {
    const val = {
      vehicleId: vehicleId,
      driverId: data?.id,
      type: value,
      driverData:filterDataDriver
    }
    dispatch(updateAssignVehicle(val));
    handleClose();
  }

  const breadcrumbPaths = [
    { name: 'Assign Vehicle', url: '', className: 'colorBlue' },
  ];

  const handelSearch = (val) => {
    setSearchQuery(val)
  }
  const onClickMoreIcon = (data,type) => {
    if(type?.toLowerCase() == 'reassign'){
      setVehicleId(data?.id);
      dispatch(getAssignDriver({vehicleId:data?.id}));
      setOpenDialog(true);
    }
    else{
      const val = {
        vehicleId:data?.id,
        driverId: '',
        type: value,
        driverData: filterData,
        unAssined: 'unAssined'
      }
      dispatch(updateAssignVehicle(val))
    }

  }

  const filterAllDrivers = () => {
    let filteredDriverList = [];

    if (searchQuery !== "") {
      filteredDriverList = assignDriverData.filter(driver => driver.driverName.toLowerCase().includes(searchQuery?.toLowerCase()))
    } else {
      filteredDriverList = assignDriverData
    }

    setFilterDrivers(filteredDriverList)

  }

  const handleChangePage = (event,newPage) =>{
    setPage(newPage)
    filterData = {...filterData, page:newPage}
    dispatch(getRequestVehicle(filterData))
  }

  const handleChangeRowsPerPage = (event) =>{
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    filterData = {...filterData, page:0, pageSize:parseInt(event.target.value)}
    dispatch(getRequestVehicle(filterData))
  }

  return (
    <div>
      <CommonBreadCrumb paths={breadcrumbPaths} />
      {loader ?
        <Loader />
        :
        <Grid container>
          <Grid item className="tableContainer" xs={12}>
            <Box className="contentBoxStyle">
              <TabContext value={value}>
                <Grid
                  container
                  className="tabBoxStyle"
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Grid item>
                    <TabList
                      className='minHeight32'
                      onChange={handleChange}
                      aria-label="lab API tabs example"
                      TabIndicatorProps={{
                        style: { backgroundColor: 'white' }, // Replace 'none' with your desired color
                      }}
                    >
                      <Tab label="Request" value="requested" className="tabStyle" />
                      <Tab label="Assigned" value="assigned" className="tabStyle" />
                    </TabList>
                  </Grid>
                </Grid>
                <TabPanel
                  value="requested"
                  className="vendotTable width100"
                >
                  <CommonTable
                    data={tableData}
                    onClickTableVendor={onClickTableVendor}
                    actionBtn="true"
                    handleClose={handleClose} 
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isClickable = {false}
                  />
                </TabPanel>
                <TabPanel value="assigned" className="vendotTable">
                  <CommonTable
                    data={tableData}
                    onClickTableVendor={onClickTableVendor}
                    actionBtn="true"
                    handleClose={handleClose} 
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isClickable = {false}
                    tabName={'unAssignTab'}
                    onClickMoreIcon={onClickMoreIcon}
                  />
                </TabPanel>
              </TabContext>
            </Box>
          </Grid>
        </Grid>}
      {openDialog && (
        <AllotDialog
          onSearch={handelSearch}
          type={"vechileView"}
          openDialog={openDialog}
          allotData={filterDrivers}
          title={'Available'}
          titleType={'Driver'}
          placeholder={'Search Driver'}
          handleClose={handleClose}
          submittAssign={submittAssign}
          loader={assignDriverLoader} 
        />
      )}
    </div>
  );
}

export default AssignVechileView;
